import { createContext, useContext, ReactNode, useState } from "react";

interface ReportFormContextType {
  formData: any;
  setFormData: React.Dispatch<React.SetStateAction<any>>;
  isTakingSnapshot: boolean;
  setIsTakingSnapshot: React.Dispatch<React.SetStateAction<boolean>>;
};

const ReportFormContext = createContext<ReportFormContextType | undefined>(
  undefined
);

export function ReportFormProvider({ children }: { children: ReactNode }) {
  const [formData, setFormData] = useState<any>({});
  const [isTakingSnapshot, setIsTakingSnapshot] = useState(false);

  return (
    <ReportFormContext.Provider value={{ formData, setFormData, isTakingSnapshot, setIsTakingSnapshot }}>
      {children}
    </ReportFormContext.Provider>
  );
}

export function useReportForm() {
  const context = useContext(ReportFormContext);
  if (context === undefined) {
    throw new Error("useReportForm must be used within a ReportFormProvider");
  }
  return context;
}
